import _ from 'lodash';
import message from 'framework/modules/message';
import constants from './constants';

export default {
    // https://github.homeawaycorp.com/core-api/api-domain/blob/04e27be8768c4f1b3d67e895afcbe69ff17cd81d/src/main/java/com/homeaway/api/domain/enums/CardCode.java
    formatCardNameForLingua(cardName) {
        const cardNamesWithLodash = {
            cartasi: 'carta_si',
            carteblanche: 'carte_blanche',
            cartebleu: 'carte_bleu',
            cartebleue: 'carte_bleu', // this key does not exist in lingua, so its mapped to the other name above
            maestrointernational: 'maestro_international',
            'visa-electron': 'visa_electron',
        };
        return _.get(cardNamesWithLodash, cardName, cardName);
    },

    getSupportedCardTypesBootstrap(quote) {
        let result = [];
        const supportedCardTypes = _.get(
            quote,
            'paymentOptions.supportedCardTypes',
            []
        );
        const supportedVASCardTypes = _.get(
            quote,
            'paymentOptions.supportedVASCardTypes',
            []
        );

        if (supportedCardTypes.length > 0) {
            result = supportedCardTypes;
        } else if (supportedVASCardTypes.length > 0) {
            result = supportedVASCardTypes;
        }

        // correct names
        result = this.formatSupportedCardTypesBootstrapNames(
            _.cloneDeep(result)
        );

        return result;
    },

    formatSupportedCardTypesBootstrapNames(cards) {
        const corrections = {
            visa_electron: 'visa-electron',
            carte_bleu: 'cartebleue',
        };

        return cards.map((card) =>
            _.get(corrections, card.toLowerCase(), card)
        );
    },

    /**
     * hapi returns non-delimited card types, e.g. visaelectron instead of visa_electron
     * massage the names to work for
     * @param {array of card names} supportedCardTypesBootstrap
     */
    formatHapiCardNames(supportedCardTypesBootstrap) {
        return supportedCardTypesBootstrap.map((card) =>
            card.replace(/_|-/g, '').toUpperCase()
        );
    },

    getMessageForCardType(card) {
        return message.read(
            `traveler.payments.cc.${this.formatCardNameForLingua(
                card.toLowerCase()
            )}`
        );
    },

    getShownCardFormat(cardType = '', cardTypes = []) {
        let shownCardFormat = '';
        if (
            cardType &&
            cardType.length > 0 &&
            !cardTypes.includes(cardType.toUpperCase())
        ) {
            const formatOnCard = _.get(
                constants.CARDTYPE_FORMAT_ON_CARD,
                cardType.toUpperCase()
            );
            if (formatOnCard) {
                shownCardFormat = this.getMessageForCardType(formatOnCard);
            } else {
                shownCardFormat = cardType.toUpperCase();
            }
        }
        return shownCardFormat;
    },

    getCardNames(supportedCardTypesBootstrap) {
        return supportedCardTypesBootstrap
            .filter((card) => card.toLowerCase() !== constants.CARD_TYPES.AMEX)
            .map((card) => this.getMessageForCardType(card))
            .join(', ');
    },

    hasAmex(supportedCardTypesBootstrap) {
        return supportedCardTypesBootstrap.some(
            (supportedCardType) =>
                supportedCardType.toLowerCase() === constants.CARD_TYPES.AMEX
        );
    },

    isWalletCardTypeSupported(cardType, supportedCardTypesBootstrap) {
        if (!cardType) {
            return true;
        }
        const cardTypeUpper = cardType.replace(/_|-/g, '').toUpperCase();
        return supportedCardTypesBootstrap.some(
            (supportedCardType) =>
                supportedCardType.replace(/_|-/g, '').toUpperCase() ===
                cardTypeUpper
        );
    },
};
